// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__1Z7FH","content":"Consent_content__3wWFB","footer":"Consent_footer__21vG5"};